<div class="n-oldalfej">
  <div>
    <h2>Pénztárgép (OPG)</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · napi zárások a NAV Online Pénztárgép rendszeréből</span>
  </div>
  <div class="spacer"></div>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" *ngIf="aktiv.ugyfelId" [disabled]="szinkronFut" (click)="szinkronMost()">
    <ion-icon slot="start" [name]="szinkronFut ? 'hourglass-outline' : 'sync-outline'"></ion-icon>{{ szinkronFut ? 'Szinkron…' : 'Szinkron most' }}
  </ion-button>
</div>

<div class="naplo-wrap">
  <div *ngIf="!aktiv.ugyfelId" class="ures"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet az Ügyfelek menüben a pénztárgép-modul megnyitásához.</div>

  <ng-container *ngIf="aktiv.ugyfelId">
    <!-- Pénztárgépek + OPG beállítás -->
    <div class="ket-oszlop">
      <div class="n-panel">
        <div class="n-panel-cim"><ion-icon name="hardware-chip-outline"></ion-icon> Pénztárgépek</div>
        <div>
          <div *ngIf="!penztargepek.length && !ujPt" class="halvany">Még nincs pénztárgép. Az első napi zárásnál automatikusan felkerül, vagy add hozzá kézzel.</div>
          <table class="n-racs" *ngIf="penztargepek.length">
            <thead><tr><th>AP-szám</th><th>Megnevezés</th><th>Típus</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let p of penztargepek">
                <td><b>{{ p.ap_szam }}</b></td><td>{{ p.megnevezes || '—' }}
                  <!-- E-pénztárgép: a NAV wrap.xml-je jelzi a be nem küldött dokumentumokat (OPF 1.3). -->
                  <div *ngIf="p.hianyzo_rekordok?.length" class="pt-hiany" [title]="'Hiányzó sorszámok: ' + p.hianyzo_rekordok.join(', ')">
                    <ion-icon name="warning-outline"></ion-icon> {{ p.hianyzo_rekordok.length }} dokumentumot nem küldött be a NAV-nak
                    ({{ p.hianyzo_rekordok.slice(0, 8).join(', ') }}{{ p.hianyzo_rekordok.length > 8 ? ', …' : '' }})</div></td>
                <td class="halvany">{{ p.tipus === 'epg' ? 'e-pénztárgép' : p.tipus === 'opg' ? 'online pénztárgép' : '—' }}</td>
                <td class="jobb"><ion-button size="small" fill="clear" color="danger" (click)="ptTorol(p)"><ion-icon slot="icon-only" name="trash"></ion-icon></ion-button></td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="ujPt" class="uj-pt">
            <div class="nav-pt-sor">
              <ion-button size="small" fill="outline" [disabled]="navPtFut" (click)="navPtLekard()">
                <ion-spinner *ngIf="navPtFut" name="dots"></ion-spinner>
                <span *ngIf="!navPtFut"><ion-icon slot="start" name="cloud-download"></ion-icon>NAV-ból lekérés</span>
              </ion-button>
              <span class="halvany" style="font-size:.78rem">A NAV-nál nyilvántartott pénztárgépek automatikus lekérése.</span>
            </div>
            <div *ngIf="navPtLista?.length" class="nav-pt-lista">
              <ion-chip *ngFor="let a of navPtLista" [color]="ujPt.ap_szam === a.ap_szam ? 'primary' : (a.felveve ? 'medium' : 'success')" [outline]="ujPt.ap_szam !== a.ap_szam" (click)="navPtValaszt(a)">
                <ion-icon name="calculator"></ion-icon>
                <ion-label><b>{{ a.ap_szam }}</b><small *ngIf="a.felveve"> · már felvéve</small></ion-label>
              </ion-chip>
            </div>
            <div *ngIf="navPtLista && !navPtLista.length" class="halvany" style="font-size:.8rem">A NAV nem adott vissza pénztárgépet. Add meg kézzel az AP-számot.</div>
            <ion-input fill="outline" label="AP-szám" labelPlacement="stacked" [(ngModel)]="ujPt.ap_szam" placeholder="pl. Y12300123"></ion-input>
            <div class="halvany" style="font-size:.78rem">NAV teszt-módban (OSA-beállítás) erre az AP-számra tesztadat is kérhető:
              <a class="link" (click)="tesztadat()">tesztadat generálása</a> – e-pénztárgépre (pl. B…) dokumentum- és riportcsomag, online pénztárgépre naplóállományok.</div>
            <ion-input fill="outline" label="Megnevezés" labelPlacement="stacked" [(ngModel)]="ujPt.megnevezes" placeholder="pl. Bolti kassza"></ion-input>
            <div><ion-button size="small" style="--background:var(--naplo)" (click)="ptMent()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
              <ion-button size="small" fill="clear" (click)="ujPt = null">Mégse</ion-button></div>
          </div>
          <button type="button" class="ov-gomb" *ngIf="!ujPt" (click)="ptUj()"><ion-icon name="add"></ion-icon>Pénztárgép hozzáadása</button>
        </div>
      </div>

      <div class="n-panel">
        <div class="n-panel-cim"><ion-icon name="mail-outline"></ion-icon> Napi zárás – email + szinkron</div>
        <p class="halvany" style="margin:-4px 0 10px;font-size:12.5px">Új napi zárásnál a rendszer PDF-et generál és erre a címre küldi.</p>
        <div>
          <ion-input fill="outline" label="Email-célcím" labelPlacement="stacked" type="email" [(ngModel)]="beall.email_cel" placeholder="konyvelo@pelda.hu"></ion-input>
          <ion-input fill="outline" label="Email tárgy (opcionális)" labelPlacement="stacked" [(ngModel)]="beall.email_targy" placeholder="Pénztárgép napi zárás"></ion-input>
          <div style="margin-top:8px;display:flex;gap:8px;flex-wrap:wrap">
            <ion-button size="small" style="--background:var(--naplo)" (click)="beallMent()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
            <ion-button size="small" fill="outline" [disabled]="szinkronFut" (click)="szinkronMost()">
              <ion-spinner *ngIf="szinkronFut" name="dots"></ion-spinner>
              <span *ngIf="!szinkronFut"><ion-icon slot="start" name="sync"></ion-icon>Szinkron most</span>
            </ion-button>
            <ion-button size="small" fill="outline" color="medium" [disabled]="szinkronFut" (click)="szinkronMost(true)" title="Az összes zárás újratöltése a NAV-tól (a meglévők frissülnek)">
              <ion-spinner *ngIf="szinkronFut" name="dots"></ion-spinner>
              <span *ngIf="!szinkronFut"><ion-icon slot="start" name="refresh-circle"></ion-icon>Teljes újraszinkron</span>
            </ion-button>
            <ion-button size="small" fill="clear" (click)="afaPotlas()" title="Hiányzó ÁFA-kulcsok pótlása a standard leképezésből (A=5/B=18/C=27/D=0/E=0), NAV nélkül">
              <ion-icon slot="start" name="pricetags-outline"></ion-icon>ÁFA-kulcs pótlása
            </ion-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Könyvelési célpont: hová kerüljön a napi zárás bevételként -->
    <div class="n-panel">
      <div class="n-panel-cim"><ion-icon name="journal-outline"></ion-icon> Könyvelési célpont – napi zárás bevételként</div>
      <p class="halvany" style="margin:-4px 0 10px;font-size:12.5px">
        A napi zárást a rendszer az ügyfél könyvelési módja szerint vezeti fel
        (<b>{{ kettos ? 'kettős könyvvitel' : 'egyszeres (napló)' }}</b>), ÁFA-kulcsonként, készpénzes bevételként.
        Ha üresen hagyod, automatikusan választ (első áfás bevétel rovat / termékértékesítés árbevétel-számla / első pénztár).</p>
      <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end">
        <ng-container *ngIf="!kettos">
          <label class="cel-mezo">Bevétel rovat
            <select [(ngModel)]="beall.konyveles_rovat_id">
              <option [ngValue]="null">— automatikus —</option>
              <option *ngFor="let r of konyvCel.rovatok" [ngValue]="r.id">{{ r.rovatszam }} – {{ r.nev }}</option>
            </select>
          </label>
          <label class="cel-mezo">Pénztár (készpénz)
            <select [(ngModel)]="beall.konyveles_penztar_id">
              <option [ngValue]="null">— automatikus —</option>
              <option *ngFor="let p of konyvCel.penztarak" [ngValue]="p.id">{{ p.azonosito }} – {{ p.nev }}</option>
            </select>
          </label>
        </ng-container>
        <ng-container *ngIf="kettos">
          <label class="cel-mezo">Árbevétel-főkönyvi szám
            <select [(ngModel)]="beall.konyveles_arbevetel_szamla">
              <option [ngValue]="null">— automatikus —</option>
              <option *ngFor="let a of konyvCel.arbevetel" [ngValue]="a.szamlaszam">{{ a.szamlaszam }} – {{ a.nev }}</option>
            </select>
          </label>
          <span class="halvany" style="font-size:.8rem;max-width:320px">A pénztár (381) és a fizetendő ÁFA (467) a kettős könyvelés beállításából jön.</span>
        </ng-container>
        <ion-button size="small" style="--background:var(--naplo)" (click)="beallMent()"><ion-icon slot="start" name="save"></ion-icon>Célpont mentése</ion-button>
      </div>
    </div>

    <!-- Napi zárások -->
    <div class="n-szuro-sor">
      <label>Pénztárgép
        <select [(ngModel)]="apSzuro" (ngModelChange)="napizarasokBetolt()">
          <option value="mind">Mind</option>
          <option *ngFor="let p of penztargepek" [value]="p.ap_szam">{{ p.ap_szam }}{{ p.megnevezes ? ' – ' + p.megnevezes : '' }}</option>
        </select>
      </label>
      <label>Év
        <select [(ngModel)]="evSzuro" (ngModelChange)="napizarasokBetolt()">
          <option value="mind">Összes év</option>
          <option *ngFor="let e of evek" [value]="e">{{ e }}</option>
        </select>
      </label>
      <span class="spacer"></span>
      <span class="halvany">{{ napizarasok.length }} napi zárás</span>
      <ion-button size="small" fill="outline" style="--color:var(--naplo);--border-color:var(--naplo)" *ngIf="napizarasok.length" [disabled]="konyvFut" (click)="konyvelNemKonyveltek()" title="A még nem könyvelt napi zárások felvezetése a könyvelésbe bevételként">
        <ion-spinner *ngIf="konyvFut" name="dots"></ion-spinner>
        <span *ngIf="!konyvFut"><ion-icon slot="start" name="journal"></ion-icon>Nem könyveltek felvezetése</span>
      </ion-button>
    </div>

    <div *ngIf="!napizarasok.length" class="ures"><ion-icon name="receipt-outline"></ion-icon>Nincs napi zárás ebben a nézetben. Indíts szinkront, vagy állítsd be a NAV technikai usert az OSA-beállításnál.</div>

    <div class="tabla-wrap" *ngIf="napizarasok.length">
      <table class="n-racs">
        <thead><tr><th>Z-szám</th><th>Dátum</th><th>Pénztárgép</th><th class="jobb">Forgalom</th><th class="kozep">Nyugta</th><th class="kozep">ABCDEF</th><th class="kozep">Gyűjtő</th><th class="kozep">Email</th><th class="jobb">Műveletek</th></tr></thead>
        <tbody>
          <tr *ngFor="let z of napizarasok">
            <td><a class="link" (click)="reszletNyit(z)"><b>Z{{ z.zaras_szam }}</b></a></td>
            <td style="white-space:nowrap">{{ z.datum || '—' }} <span class="halvany">{{ z.ido || '' }}</span></td>
            <td>{{ z.ap_szam }} <span *ngIf="z.forras === 'epg'" class="pt-cimke" title="E-pénztárgép – napi forgalmi jelentés">e-PG</span></td>
            <td class="jobb">{{ z.forgalom_brutto | number:'1.0-0' }} Ft</td>
            <td class="kozep">{{ z.nyugta_db }}</td>
            <td class="kozep">{{ z.afa_db }}</td>
            <td class="kozep">{{ z.gyujto_db }}</td>
            <td class="kozep"><ion-icon *ngIf="z.email_kuldve" name="checkmark-circle" color="success" title="Kiküldve"></ion-icon><span *ngIf="!z.email_kuldve" class="halvany">—</span></td>
            <td class="jobb muveletek">
              <ion-button size="small" fill="clear" (click)="reszletNyit(z)" title="Részletek"><ion-icon slot="icon-only" name="eye"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="pdfNyit(z)" title="PDF"><ion-icon slot="icon-only" name="document-text"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="primary" (click)="emailKuld(z)" title="Email (újra)küldése"><ion-icon slot="icon-only" name="send"></ion-icon></ion-button>
              <ion-icon *ngIf="z.konyvelt" name="journal" color="success" [title]="'Könyvelve' + (z.konyvelt_mod ? ' (' + z.konyvelt_mod + ')' : '')" style="vertical-align:middle;margin:0 6px"></ion-icon>
              <ion-button *ngIf="!z.konyvelt" size="small" fill="clear" style="--color:var(--naplo)" [disabled]="konyvFut" (click)="konyvel(z)" title="Felvezetés a könyvelésbe bevételként"><ion-icon slot="icon-only" name="journal-outline"></ion-icon></ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<!-- Napi zárás részletei: ABCDEF + gyűjtők -->
<ion-modal #reszletModal class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title *ngIf="reszlet">Napi zárás – Z{{ reszlet.zaras_szam }} ({{ reszlet.ap_szam }})</ion-title>
      <ion-buttons slot="end"><ion-button (click)="reszletModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="reszlet">
      <div class="meta-sav">
        <span><b>Dátum:</b> {{ reszlet.datum ? (reszlet.datum | slice:0:10) : '—' }} {{ reszlet.ido || '' }}</span>
        <span><b>Bruttó forgalom:</b> {{ reszlet.forgalom_brutto | number:'1.0-0' }} Ft</span>
        <span><b>Nyugta db:</b> {{ reszlet.nyugta_db }}</span>
      </div>

      <h3>{{ epg ? 'Forgalmi gyűjtők (e-pénztárgép)' : 'ÁFA-kategóriák (ABCDEF)' }}</h3>
      <table class="n-racs">
        <thead><tr><th class="kozep">{{ epg ? 'Gyűjtő' : 'Kategória' }}</th><th class="jobb">ÁFA-kulcs</th>
          <th class="jobb" *ngIf="epg">Nettó</th><th class="jobb" *ngIf="epg">ÁFA</th><th class="jobb">Bruttó</th></tr></thead>
        <tbody>
          <tr *ngFor="let a of reszlet.afak"><td class="kozep"><b>{{ a.kod || a.kategoria }}</b></td><td class="jobb">{{ a.afa_kulcs != null ? a.afa_kulcs + '%' : '—' }}</td>
            <td class="jobb" *ngIf="epg">{{ a.netto != null ? (a.netto | number:'1.0-0') + ' Ft' : '—' }}</td><td class="jobb" *ngIf="epg">{{ a.afa != null ? (a.afa | number:'1.0-0') + ' Ft' : '—' }}</td>
            <td class="jobb">{{ a.brutto | number:'1.0-0' }} Ft</td></tr>
          <tr *ngIf="!reszlet.afak?.length"><td [attr.colspan]="epg ? 5 : 3" class="ures">Nincs ÁFA-kategória adat.</td></tr>
        </tbody>
        <tfoot *ngIf="reszlet.afak?.length"><tr><td [attr.colspan]="epg ? 4 : 2" class="jobb"><b>Összesen</b></td><td class="jobb"><b>{{ afaOssz(reszlet) | number:'1.0-0' }} Ft</b></td></tr></tfoot>
      </table>

      <ng-container *ngIf="reszlet.bontas?.tipusok?.length">
        <h3>Bizonylattípusonként <small class="halvany" *ngIf="reszlet.bontas.riport">{{ reszlet.bontas.riport }}</small></h3>
        <table class="n-racs">
          <thead><tr><th>Bizonylat</th><th class="jobb">Darab</th><th class="jobb">Összeg</th></tr></thead>
          <tbody><tr *ngFor="let t of reszlet.bontas.tipusok"><td>{{ t.nev }}</td><td class="jobb">{{ t.darab }}</td><td class="jobb">{{ t.osszeg | number:'1.0-0' }} Ft</td></tr></tbody>
        </table>
        <p class="halvany" style="font-size:.8rem;margin:6px 2px 0">A forgalom: nyugta + egyszerűsített számla + számla, az érvénytelenítésekkel csökkentve, a módosításokkal együtt.
          A számlák az Online Számlában is megjelennek – könyveléskor ne számold kétszer.</p>
      </ng-container>

      <h3>Gyűjtők</h3>
      <table class="n-racs">
        <thead><tr><th>Megnevezés</th><th class="kozep">Kód</th><th class="kozep">ÁFA-kat.</th><th class="jobb">ÁFA-kulcs</th><th class="jobb">Darab</th><th class="jobb">Bruttó</th></tr></thead>
        <tbody>
          <tr *ngFor="let g of reszlet.gyujtok">
            <td><b>{{ g.megnevezes || g.kod || '—' }}</b></td>
            <td class="kozep halvany">{{ g.kod || '—' }}</td>
            <td class="kozep">{{ gyKat(g) }}</td>
            <td class="jobb">{{ gyAfa(g) != null ? gyAfa(g) + '%' : '—' }}</td>
            <td class="jobb">{{ g.darab ? (g.darab | number:'1.0-0') : '—' }}</td>
            <td class="jobb">{{ g.brutto | number:'1.0-0' }} Ft</td>
          </tr>
          <tr *ngIf="!reszlet.gyujtok?.length"><td colspan="6" class="ures">Nincs gyűjtő adat.</td></tr>
        </tbody>
      </table>
      <p *ngIf="csakKategoria" class="halvany" style="font-size:.8rem;margin:6px 2px 0">
        Ez a pénztárgép a napi zárásban <b>ÁFA-kategóriánként összesít</b> (A/C/E = …00). Ha több gyűjtőd van azonos ÁFA-kulccsal
        (pl. két 27%-os), azok a napi zárásban <b>egy tételben</b> (C00) jönnek – a NAV-adat nem bontja szét őket, csak a nyomtatott blokk.
      </p>

      <div style="margin-top:14px;display:flex;gap:8px;flex-wrap:wrap">
        <ion-button size="small" fill="outline" color="danger" (click)="pdfNyit(reszlet)"><ion-icon slot="start" name="document-text"></ion-icon>PDF megnyitása</ion-button>
        <ion-button size="small" style="--background:var(--naplo)" (click)="emailKuld(reszlet)"><ion-icon slot="start" name="send"></ion-icon>Email kiküldése</ion-button>
        <ion-button *ngIf="!konyveltE(reszlet)" size="small" fill="outline" style="--color:var(--naplo);--border-color:var(--naplo)" [disabled]="konyvFut" (click)="konyvel(reszlet)"><ion-icon slot="start" name="journal"></ion-icon>Felvezetés a könyvelésbe</ion-button>
        <span *ngIf="konyveltE(reszlet)" class="halvany" style="display:inline-flex;align-items:center;gap:5px;color:var(--ion-color-success)"><ion-icon name="journal"></ion-icon>Könyvelve</span>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
